var map = {
	"./": 2710,
	"./bnb.png": 325,
	"./eth.png": 2762,
	"./image-solid.png": 4344,
	"./index": 2710,
	"./index.js": 2710,
	"./metamask.png": 8843,
	"./scai.png": 3277,
	"./walletConnectIcon.svg": 9854,
	"./x.svg": 1275
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;